import React from "react"
import logo from "./logo_transparent.png"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import { Routes, Link, Route, BrowserRouter } from "react-router-dom"
import "./Home.css"
import { Card, CardActions, CardContent, Typography } from "@mui/material"

function Home() {
  return (
    <div className="home-App">
      <Grid container spacing={2} sx={{ padding: "90px", paddingTop: "150px" }}>
        <Grid item xs={12} md={7}>
          <div className="home-column column-left">
            <div className="home-title">
              Welcome to Friends of the Miracle Mile
            </div>
            <div className="home-text">
              Friends of the Miracle Mile is a California nonprofit 501c(3)
              corporation dedicated to improving the quality of life in our
              greater Los Angeles community since 2004. We actively raise funds
              for our programs and support other projects that align with our
              vision for a better neighborhood.
            </div>
            <Link to="/about-us" className="home-learn-more-button">
              About Us
            </Link>
          </div>
        </Grid>
        <Grid item xs={12} md={5}>
          <div className="home-column column-right">
            <img src={logo} className="App-logo" alt="logo" />
          </div>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          width: "90%",
          margin: "auto",
          marginTop: "80px",
        }}
      >
        <h3 className="h3-3">Programs</h3>
        <Grid item xs={12}>
          <Card
            sx={{
              margin: "auto",
              width: "90%",
              padding: "20px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              boxShadow: "0px 0px 60px rgba(149, 163, 127, 0.8)",
              mb: 3,
            }}
          >
            <CardContent sx={{ textAlign: "center" }}>
              <Typography
                sx={{ fontSize: 24, fontFamily: "Arvo", fontWeight: 700 }}
                gutterBottom
              >
                <em> Expungement Program</em>
              </Typography>
              <Typography
                variant="body1"
                sx={{ margin: "30px", fontSize: "20px" }}
              >
                Our expungement program focuses on clearing records for those
                persons who have been released after being incarcerated for
                non-violent offenses. We are tireless in our efforts to identify
                trends, improve strategies and adopt innovative approaches that
                fully encompass expungement including education and employment.
                Minority communities historically suffer from a pre-school to
                prison pipeline. Prisons are filled with men and women of color
                who become part of this cycle. A conviction can limit
                employment, housing, education, and immigration opportunities.
                Our expungement program can help alleviate these barriers.
              </Typography>
            </CardContent>
            <CardActions>
              <Link to="/check-eligibility" className="home-check-button">
                Check Eligibility
              </Link>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          width: "85%",
          margin: "auto",
          marginTop: "80px",
        }}
      >
        <h3 className="h3-2">3 Tiers Of Our Expungement Program</h3>

        <Grid item xs={12}>
          <Typography
            variant="h3"
            sx={{
              fontSize: "20px",
              fontFamily: "Arvo",
              fontStyle: "italic",
            }}
          >
            Tier 1 - Expungement
          </Typography>
        </Grid>
        <Grid item xs={3} sm={2} md={1}>
          <Typography
            variant="h3"
            sx={{
              fontFamily: "DM Sans",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "150px",
              textAlign: "center",
              lineHeight: "195px",
              color: "#BBBBAC",
            }}
          >
            1
          </Typography>
        </Grid>
        <Grid item xs={9} sm={10} md={11}>
          <Typography
            sx={{
              fontSize: "20px",
              fontFamily: "DM Sans",
              fontStyle: "normal",
              fontWeight: "400",
              padding: "20px",
              paddingTop: "40px",
            }}
          >
            FMM partners with other nonprofits and attorneys to expunge
            non-violent criminal persons. Clemency for non-violent offenders is
            the core of our advocacy as we strive to provide sustainable career
            opportunities for individuals directly affected by the war on drugs.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="h3"
            sx={{
              fontSize: "20px",
              fontFamily: "Arvo",
              fontStyle: "italic",
            }}
          >
            Tier 2 - Jobs Readiness
          </Typography>
        </Grid>
        <Grid item xs={3} sm={2} md={1}>
          <Typography
            variant="h3"
            sx={{
              fontFamily: "DM Sans",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "150px",
              textAlign: "center",
              lineHeight: "195px",
              color: "#BBBBAC",
            }}
          >
            2
          </Typography>
        </Grid>
        <Grid item xs={9} sm={10} md={11}>
          <Typography
            sx={{
              fontSize: "20px",
              fontFamily: "DM Sans",
              fontStyle: "normal",
              fontWeight: "400",
              padding: "20px",
              paddingTop: "40px",
            }}
          >
            Although cannabis use is legal in only two-thirds of the country, it
            is among the fastest-growing job markets in the United States.
            According to Leafy, the industry employs more than 200,000 full-time
            workers. It is considered "America's hidden job boom." In 2019, the
            industry added over 64,000 jobs and a 44% increase is expected in
            2022 to create an additional 20,000 jobs in California and Florida
            alone.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="h3"
            sx={{
              fontSize: "20px",
              fontFamily: "Arvo",
              fontStyle: "italic",
            }}
          >
            Tier 3 - Jobs Training
          </Typography>
        </Grid>
        <Grid item xs={3} sm={2} md={1}>
          <Typography
            variant="h3"
            sx={{
              fontFamily: "DM Sans",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "150px",
              textAlign: "center",
              lineHeight: "195px",
              color: "#BBBBAC",
            }}
          >
            3
          </Typography>
        </Grid>
        <Grid item xs={9} sm={10} md={11}>
          <Typography
            sx={{
              fontSize: "20px",
              fontFamily: "DM Sans",
              fontStyle: "normal",
              fontWeight: "400",
              padding: "20px",
              paddingTop: "40px",
              marginBottom: "80px",
            }}
          >
            Our workshops offer Strategic Interviewing Skills, Resumes that Land
            Interviews, Selling Yourself, How to Generate Leads, and a Strategic
            Self-Marketing Plan. This curriculum prepares job seekers with the
            skills necessary to get and maintain employment. Our
            industry-specific job search approach provides job seekers an
            essential advantage in getting employers' attention. Exclusive
            access to our database of Co-Ops and dispensaries in the greater Los
            Angeles region provides direction for each participant in their job
            search.
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}

export default Home
